import React, { useEffect, useState } from "react";
import axios from "axios";
import { Notify } from "notiflix";
import CommonProfileCard from "../CommonProfileCard/CommonProfileCard";
import ProfileSkeleton from "../ProfileSkeleton/ProfileSkeleton"

const ShortListedSection = () => {
    const [showAll, setShowAll] = useState(false);
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(true); 
    const visibleProfiles = showAll ? profiles : profiles.slice(0, 4);
    const [Reload, setReload] = useState(false);

    useEffect(() => {
        const fetchProfiles = async () => {
            setLoading(true);
            try {
                const token = JSON.parse(localStorage.getItem("kkm_auth"));
                const headers = {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                };

                const response = await axios.get(
                    "https://kovaikongunadumatrimony.com/kkm_backend/public/api/my-short-list-profile-list",
                    { headers }
                );

                if (response.data.status === true) {
                    setProfiles(response.data.data);
                } else {
                    Notify.failure(response.data.message);
                }
            } catch (error) {
                Notify.failure("Something went wrong!");
            }
            setLoading(false);
        };

        fetchProfiles();
    }, [Reload]);

    return (
        <div className={`all-profiles-section ${showAll ? "scrollable" : ""}`}>
            <h2>Short Listed Profiles ({profiles.length})</h2>
            <div className="row profiles-grid">
                {loading
                    ? Array(4) // Show 4 skeletons while loading
                          .fill()
                          .map((_, index) => (
                              <div className="col-xl-6 col-12 mb-4" key={index}>
                                  <ProfileSkeleton />
                              </div>
                          ))
                    : visibleProfiles.map((profile, index) => (
                          <div className="col-xl-6 col-12 mb-4" key={index}>
                              <CommonProfileCard
                                  profile={profile}
                                  setReload={setReload}
                              />
                          </div>
                      ))}
            </div>
            {!loading && (
                <div className="view-all-wrapper">
                    <button
                        className="view-all-btn"
                        onClick={() => setShowAll(!showAll)}
                    >
                        {showAll ? "Show Less" : "View All"}
                    </button>
                </div>
            )}
        </div>
    );
};

export default ShortListedSection;
